var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-template",
    [
      _c(
        "va-card",
        { staticClass: "pa-6" },
        [
          _c("div", { staticClass: "va-title mb-2" }, [
            _vm._v(_vm._s(_vm.$t("signUp.title")))
          ]),
          _vm._v(" " + _vm._s(_vm.$t("signUp.content")) + " "),
          _vm.mfaEnabled
            ? _c(
                "div",
                { staticClass: "d-flex justify-space-between mt-6" },
                [
                  _c("google-sign-in", {
                    staticClass: "mr-4",
                    attrs: { signup: "" }
                  }),
                  _c("apple-sign-in", {
                    staticClass: "mr-4",
                    attrs: { signup: "" }
                  }),
                  _c("microsoft-sign-in", { attrs: { signup: "" } })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-form",
            {
              ref: "signUpForm",
              attrs: { "lazy-validation": "", onSubmit: "return false;" },
              on: { submit: _vm.onSubmit },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("va-text-field", {
                staticClass: "mt-6",
                attrs: {
                  rules: [_vm.required, _vm.validMail],
                  label: _vm.$t("common.email"),
                  disabled: _vm.success
                },
                model: {
                  value: _vm.formData.email,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "email", $$v)
                  },
                  expression: "formData.email"
                }
              }),
              _c("va-text-field", {
                staticClass: "mt-6",
                attrs: {
                  rules: [_vm.required],
                  label: _vm.$t("common.firstname"),
                  disabled: _vm.success
                },
                model: {
                  value: _vm.formData.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "firstName", $$v)
                  },
                  expression: "formData.firstName"
                }
              }),
              _c("va-text-field", {
                staticClass: "mt-6",
                attrs: {
                  rules: [_vm.required],
                  label: _vm.$t("common.lastname"),
                  disabled: _vm.success
                },
                model: {
                  value: _vm.formData.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "lastName", $$v)
                  },
                  expression: "formData.lastName"
                }
              }),
              _c(
                "div",
                { staticClass: "text-right mb-3 mt-1" },
                [
                  _c("router-link", { attrs: { to: "/auth/signin" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("signUp.back")) + " ")
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex mt-5" },
                [
                  _c("va-button", {
                    staticClass: "flex-grow-1",
                    attrs: {
                      submit: "",
                      disabled: !_vm.valid || _vm.success,
                      loading: _vm.$store.getters["session/isLoading"],
                      cta: _vm.$t("signUp.title")
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.success
            ? _c("va-notification", { attrs: { type: "success" } }, [
                _vm._v(" " + _vm._s(_vm.$t("signUp.success")) + " ")
              ])
            : _vm._e(),
          _vm.error && !_vm.success
            ? _c("va-notification", { attrs: { type: "error" } }, [
                _vm._v(" " + _vm._s(_vm.$t("signUp.error")) + " ")
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }